<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Traslados</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-6">
              <a
                v-if="mostrarRefresh"
                class="btn btn-sm btn-info"
                @click="refreshData"
                href="#"
              >Refrescar</a>
            </div>
            <div class="col-sm-6">
              <div class="form-inline justify-content-sm-end">
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Search"
                  v-model="searchtext"
                  type="text"
                  v-on:keyup.enter="filterData"
                />
                <div class="input-group-append">
                  <button class="btn btn-link btn-sm" type="button" v-on:click="filterData">
                    <i class="fa fa-search"></i>
                  </button>
                  <button class="btn btn-link btn-sm" type="button" v-on:click="clearFilterData">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filtro_estado"
                  @change="filterData"
                >
                  <option value>Todos</option>
                  <option value="9">Anulado</option>
                  <option value="A">Abierto</option>
                  <option value="B">Cerrado</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <SalidaTrasladoTableComponent />
      </div>
    </div>
    <div
      aria-hidden="true"
      class="onboarding-modal modal fade animated"
      id="modalAddReqTrasladoNew"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-lg modal-centered" role="document">
        <div class="modal-content text-center">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            <span class="close-label">Cancelar</span>
            <span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding">
            <div class="onboarding-content with-gradient">
              <div class="text-center">
                <h4 class="onboarding-title text-center">
                  Nueva salida por requerimiento de traslado
                </h4>
              </div>
              <form>
                <div class="row">
                  <div class="col-md-12">
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: ""
    };
  },
  mounted() {},
  methods: {
    
  }
};
</script>
